import React, { useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom';
import { Button, Col, Row, Table, UncontrolledTooltip, Modal, ModalBody } from 'reactstrap';
import Skeleton from "react-loading-skeleton";
import Image from '../../components/Image'
import dummyRoundedImage from "../../assets/images/dummy-rounded-image.png"
import { getAllAgents, makeAgentPrimary, updateAgentStatus } from '../../helper/backend-methods';
import { showToast } from '../../components/Toast';
import { formatTimeFromSeconds } from '../../helper/format';
import { EmptyRow } from '../../components/EmptyState';
import campaignSuccess from "../../assets/images/campaign-success.png"
import moment from 'moment';
import ChatWidget from '../../components/ChatWidget';
import { useHorizontalScrollShadow } from '../../hooks/useHorizontalScrollShadow';
import { useAppContext } from '../../context/AppContext';

const ListAgents = () => {
    const { scrollRef, isScrolled } = useHorizontalScrollShadow();
    const [loading, setLoading] = useState(false)
    const [agents, setAgents] = useState([])
    const [selectedAgent, setSelectedAgent] = useState("")
    const [primarySuccessModal, setPrimarySuccessModal] = useState(false)
    const [update, setUpdate] = useState(0)
    const [keyword, setKeyword] = useState("");

    const [selectedVoice, setSelectedVoice] = useState(1);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentlyPlayingVoice, setCurrentlyPlayingVoice] = useState(null);
    const audioRef = useRef(null);

    const keywordRef = useRef("");
    const { openQuickStart, quickStartAgentsCreated } = useAppContext();

    // Also reload when the quick-start pop-up creates an agent on top of this page.
    useEffect(() => {
        fetchAgents();
    }, [update, quickStartAgentsCreated])

    const fetchAgents = (limit = 30, offset = 0, keyword = "") => {
        setLoading(true)
        setAgents([])
        getAllAgents({ ...(keyword && keyword.length && { search: keyword }) }).then((data) => {
            if (data.data) {
                setAgents(data.data ? data.data : [])
            }
            else {
                showToast("error", "Request Failed", data.message)
            }
            setLoading(false)
        }).catch((err) => {
            showToast("error", "Request Failed", err.message)
        })
    }
    const searchByKeyword = (e) => {
        e.preventDefault();
        setKeyword(keywordRef.current.value);
        fetchAgents(30, 0, keywordRef.current.value)
    }

    const changeAgentStatus = (id, status) => {
        updateAgentStatus({ _id: id, isActive: status }).then((data) => {
            if (data) {
                setUpdate(prev => prev + 1)
            }
            else {
                showToast("error", "Request Failed", data.message)
            }
        }).catch((err) => {
            showToast("error", "Request Failed", err.message)
        })
    }


    const handlePlayPause = async (voice, voiceSrc) => {
        // If the same voice is clicked again, pause it
        if (currentlyPlayingVoice === voice._id && isPlaying) {
            if (audioRef.current) {
                audioRef.current.pause();
                setIsPlaying(false);
            }
            return;
        }

        // Stop the currently playing audio (if any)
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            audioRef.current.src = ''; // Clear the src to stop fetching
        }

        // If voiceSrc is invalid, exit early
        if (!voiceSrc) return;

        try {
            // Create new audio object
            const audio = new Audio(voiceSrc);

            // Add ended event listener to reset state when audio finishes
            audio.onended = () => {
                setIsPlaying(false);
                setCurrentlyPlayingVoice(null);
            };
            // Wait for the metadata to load to ensure validity
            audio.onloadedmetadata = async () => {
                if (audio.duration > 0) {
                    audioRef.current = audio;
                    await audioRef.current.play();
                    setIsPlaying(true); // Set playing state to true
                    setCurrentlyPlayingVoice(voice._id); // Set the currently playing voice
                } else {
                    console.error('Invalid audio file:', voiceSrc);
                    setIsPlaying(false);
                    setCurrentlyPlayingVoice(null);
                }
            };

            // Handle loading errors
            audio.onerror = () => {
                console.error('Error loading audio:', voiceSrc);
                setIsPlaying(false);
                setCurrentlyPlayingVoice(null);
            };
        } catch (error) {
            console.error('Error playing audio:', error);
            setIsPlaying(false);
            setCurrentlyPlayingVoice(null);
        }
    };

    const changePrimaryStatus = (id) => {
        makeAgentPrimary({ agentId: id }).then((data) => {
            if (data) {
                setPrimarySuccessModal(true)
                setUpdate(prev => prev + 1)
            }
            else {
                showToast("error", "Request Failed", data.message)
            }
        }).catch((err) => {
            showToast("error", "Request Failed", err.message)
        })
    }

    return (
        <div className="content-page">
            <div className="content">

                <div className="container-fluid">

                    {/* <ChatWidget agentId="agent_7201knp5ewp4fkcrd7qdw54tcyhj" userId={localStorage.getItem("userId")}></ChatWidget> */}
                    {/* <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column">
                        <div className="flex-grow-1"> */}
                    <div className="py-3 row">
                        <div className="col-12">

                            <Row className="my-2 align-items-center">
                                <Col md={8}>
                                    <h4>Agent Management</h4>
                                    <p className='text-muted fs-12'>Manage and monitor your AI agents performance</p>
                                </Col>
                                <Col md={4} className='d-flex flex-wrap justify-content-md-end gap-2'>
                                    <button
                                        type="button"
                                        onClick={() => openQuickStart({ skipWelcome: true })}
                                        title="Build an agent from your website in about a minute"
                                        className="btn btn-outline-primary font-normal py-2 px-3 rounded fs-16"
                                    >
                                        <i className="ri-magic-line"></i> Quick-start from website
                                    </button>
                                    <Link id='create-agent-btn' to={"/create-new-agent"} className="font-normal py-2 px-4 rounded fs-16 text-decoration-none text-white linear-gradient-btn"><i className="ri-add-line"></i> Create New Agent</Link>
                                </Col>
                            </Row>
                            <Row className='mb-4'>
                                <Col md={5}>
                                    {/* <form className=""> */}
                                    <div className='d-flex'>
                                        <div className="position-relative w-70 me-2">
                                            <input type="text" className="form-control p-2 ps-4" placeholder="Search..." ref={keywordRef} />
                                            <i className="ri-search-line fs-16 position-absolute text-muted top-50 translate-middle-y ms-2"></i>
                                        </div>
                                        <Button type='button' disabled={loading} onClick={(e) => { searchByKeyword(e) }} className="font-normal py-2 px-4 rounded fs-14 linear-gradient-btn">Search</Button>
                                    </div>
                                    {/* </form> */}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div className={`table-responsive${isScrolled ? ' is-scrolled' : ''}`} ref={scrollRef}>
                                    <Table hover className='border-rounded custom-listing-tables table-cols-agents table-sticky-first'>
                                        <thead>
                                            <tr>
                                                <th className="single-line">Agent</th>
                                                <th className="ps-0 single-line">Inbound</th>
                                                <th className="single-line">Voice</th>
                                                <th className="single-line">Calls Made</th>
                                                <th className="single-line">Converted</th>
                                                <th className="single-line">Unanswered</th>
                                                <th className="single-line">Minutes</th>
                                                <th className="single-line">Success Rate</th>
                                                <th className="single-line">Active</th>
                                                <th className="single-line">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                loading ?
                                                    [...Array(30)].map((a, i) => {
                                                        return <tr key={i}>
                                                            <td className="fs-12"><div className='d-flex align-items-center'><Skeleton height={40} width={40} circle={true} className='me-2' /><Skeleton height={12} width={90} /></div></td>
                                                            <td className="fs-12"><Skeleton height={12} width={80} /></td>
                                                            <td className="fs-12"><Skeleton height={12} width={80} /></td>
                                                            <td className="fs-12"><Skeleton height={12} width={80} /></td>
                                                            <td className="fs-12"><Skeleton height={12} width={90} /></td>
                                                            <td className="fs-12"><Skeleton height={12} width={80} /></td>
                                                            <td className="fs-12"><Skeleton height={12} width={80} /></td>
                                                            <td className="fs-12"><Skeleton height={12} width={80} /></td>
                                                            <td className="fs-12"><Skeleton height={12} width={40} /></td>
                                                            <td className="fs-12"><Skeleton height={12} width={40} /></td>
                                                        </tr>
                                                    }) :
                                                    agents.length === 0 ?
                                                        <EmptyRow colSpan={10} icon="ri-user-voice-line" title="No agents yet" body="Create your first AI agent to start answering calls." /> :
                                                        agents.map((agent, i) => {
                                                            return <tr key={i}>
                                                                <td className="fs-12 fw-500"><div className='d-flex align-items-center'>
                                                                    {
                                                                        agent.voiceObj.preview_url ?
                                                                            <>
                                                                                <div className='agent-list-play-button me-2'>
                                                                                    <button
                                                                                        className="play-button"
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation(); // Prevent card click event
                                                                                            handlePlayPause(agent, agent.voiceObj.preview_url); // Pass the voice and preview URL
                                                                                        }}
                                                                                    >
                                                                                        <i
                                                                                            className={
                                                                                                currentlyPlayingVoice === agent._id && isPlaying
                                                                                                    ? 'ri-pause-line'
                                                                                                    : 'ri-play-fill'
                                                                                            }
                                                                                            style={{ color: "var(--wr-primary)" }}
                                                                                        ></i>
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                            :
                                                                            <Image src={dummyRoundedImage} alt="Event" className='rounded-circle me-2' height='28px' width='28px' objectFit='cover' />
                                                                    }
                                                                    <p className='m-0'>{agent.name} <span className=' d-block text-muted fs-12 text-capitalize'>{agent.type}</span></p>
                                                                </div>
                                                                </td>
                                                                <td className='fs-20'>
                                                                    {
                                                                        agent.type === "inbound" ?
                                                                            <>
                                                                                {
                                                                                    !agent.isPrimary ?
                                                                                        <UncontrolledTooltip placement="top" style={{ minWidth: "100px" }} popperClassName="text-left" innerClassName="text-left" target={`makePrimary`}>
                                                                                            {
                                                                                                <p className='m-0 pl-3 text-left' >{"Make Primary"}</p>

                                                                                            }
                                                                                        </UncontrolledTooltip> : null
                                                                                }
                                                                                <div className="form-check form-switch gradient-switch" dir="ltr" id={!agent.isPrimary ? "makePrimary" : ""}><input role='switch' type="checkbox" checked={agent.isPrimary} onChange={(e) => { if (!agent.isPrimary) {changePrimaryStatus(agent._id); setSelectedAgent(agent.name)} }} className="form-check-input" /></div>
                                                                            </>
                                                                            : null
                                                                    }
                                                                </td>
                                                                <td className="fs-12 fw-500"><p className='m-0 text-capitalize'>{agent.voiceObj ? agent.voiceObj.language : "N/A"} ({agent.voiceObj ? agent.voiceObj.accent : "N/A"}) <span className=' d-block text-muted fs-12'>{agent.voiceObj ? agent.voiceObj.gender : "N/A"}, {agent.voiceObj ? agent.voiceObj.age : "N/A"}</span></p></td>
                                                                <td className="fs-12 fw-500">{agent.callsMade}</td>
                                                                <td className="fs-12 fw-500">{agent.callsConverted}</td>
                                                                <td className="fs-12 fw-500">{agent.callsNotAns}</td>
                                                                <td className="fs-12 fw-500 text-nowrap">{formatTimeFromSeconds(agent.totalCallMins)}</td>
                                                                <td className="fs-12 fw-500">{agent.successRate}%</td>
                                                                <td className="fs-20 fw-500"><div className="form-check form-switch gradient-switch" dir="ltr"><input role='switch' type="checkbox" checked={agent.isActive} onChange={(e) => { changeAgentStatus(agent._id, !agent.isActive); }} className="form-check-input" /></div></td>
                                                                <td className="fs-20 fw-500">
                                                                    <div className='d-flex justify-content-start align-items-center gap-2'>
                                                                        <Link to={"/update-agent/" + agent._id}><i className="ri-edit-box-line cursor-pointer" ></i></Link>

                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        })

                                            }
                                        </tbody>
                                    </Table>
                                    </div>
                                </Col>
                            </Row>
                            <Modal isOpen={primarySuccessModal} toggle={() => { setPrimarySuccessModal(false) }} centered={true} size='md'>
                                <ModalBody>
                                    <Row>
                                        <Col md={12} className='text-center'>
                                            <Image src={campaignSuccess} alt="Event" className='rounded-circle me-2' height='200px' width='200px' objectFit='cover' />
                                            <p className='fs-16 text-black'>{selectedAgent} has now become your inbound primary agent.</p>
                                            <p className='fs-16 text-black mt-1'>All other inbound agents will now be secondary.</p>
                                        </Col>
                                    </Row>
                                    <Row className="text-center mt-3">
                                        <Col>
                                            <button onClick={() => setPrimarySuccessModal(false)} className="font-normal py-2 px-4 rounded fs-16 text-decoration-none text-white linear-gradient-btn">Close</button>
                                        </Col>
                                    </Row>
                                </ModalBody>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ListAgents
